<template>
	<div id="shopcarContent">
		<div id="shopcarListCon">
			<div class="shopcarList_head">
				<div class="shopcarList_head_left">
					<img src="../../assets/img/personalhome/myshopcar1.png" />
				</div>
				<div class="shopcarList_head_right">
					<div class="shopcarList_head_right_item1">
						1.我的购物车
					</div>
					<div class="shopcarList_head_right_item1">
						2.填写数据订单核对信息
					</div>
					<div class="shopcarList_head_right_item">
						3.成功提交订单
					</div>
				</div>
			</div>
			<div class="shopcarList_content">
				<div class="personalaccount_content_right_head1">
					<div class="personalaccount_content_right_head_left">
						商品列表
					</div>
					<div class="personalaccount_content_right_head_right" style="cursor: pointer;" @click="goTop">
						返回上一页
					</div>
				</div>
				<div class="personalaccount_content_right_head1_border"></div>
				<div class="personalaccount_content_right_content" style="padding-top: 20px">
					<el-table :data="datajson" border style="width: 100%" :header-cell-style="getRowClass" :cell-style="cellStyle">
						<el-table-column prop="title" label="商品名称" width="559">
							<template slot-scope="scope">
								<div class="name_item">
									<div class="name_item_left">
										<img :src="http + scope.row.data.image" />
									</div>
									<div class="name_item_right txtnowarp2">
										{{scope.row.title}}
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="type" label="属性">
						</el-table-column>
						<el-table-column prop="data.market_price" label="市场价(￥)">
						</el-table-column>
						<el-table-column prop="data.price" label="本店价(￥)">
						</el-table-column>
						<el-table-column prop="number" label="购买数量">
						</el-table-column>
						<el-table-column  label="商品数量">
							<template slot-scope="scope">
								{{scope.row.number * scope.row.data.package}}
							</template>
						</el-table-column>
						<el-table-column prop="xprice" label="小计">
						</el-table-column>

					</el-table>
					<!--					<div class="spListAll">-->
					<!--						合计：￥{{zongPrice}}-->
					<!--					</div>-->
				</div>

				<div class="personalaccount_content_right_head1">
					<div class="personalaccount_content_right_head_left">选择收货地址</div>
					<div class="personalaccount_content_right_head_right" style="cursor: pointer;" @click="rulebox">
						使用新地址
					</div>
				</div>
				<div class="personalaccount_content_right_head1_border"></div>
				<div class="personalaccount_content_right_content">
					<div :class="{'address_item':true,'address_item_active':item.status == 1}" @click="clickFn(item,index)" v-for="(item, index) in addressData" :key="index">
						<div class="address_item_top txtnowarp">
							<span>{{item.address_name}}</span>
							<span>{{item.consignee}}</span>
						</div>
						<div class="address_item_txt txtnowarp2">
							{{item.address}}
						</div>
						<div class="address_item_txt1">
							<span>{{item.mobile}}</span>
							<div class="address_item_txt1s">
								<!--                <img src="@/assets/img/personalhome/bianji1.png"/>-->
								<!--
								修改-->
							</div>
						</div>
					</div>
				</div>
				<!--				<div class="address_btn" ></div>-->
				<div class="rulebox" v-if="ruletab">
					<div class="ruleboxin">
						<div class="rule">
							<div class="ruletop">
								<span>新增收货地址</span>
								<img src="../../../public/img/hideico1.png" alt="" class="_ico1" @click="rulebox">
							</div>
							<div class="rulecount">
								<div class="personalaccount_content_right_content1">
									<div class="personalaccount_content_right_content_item1">
										<span class="personalaccount_content_right_content_item1_txt">收货人(必填)：</span>
										<input @input="inputFn1" class="personalaccount_content_right_content_item1_inp1" type="" name="" id="consignee" />
									</div>
									<div class="personalaccount_content_right_content_item1">
										<span class="personalaccount_content_right_content_item1_txt">联系电话(必填)：</span>
										<input @input="inputFn1" class="personalaccount_content_right_content_item1_inp1" type="" name="" id="mobile" />
									</div>
									<div class="personalaccount_content_right_content_item1">
										<span class="personalaccount_content_right_content_item1_txt">地址信息(必填)：</span>
										<el-cascader class="personalaccount_content_right_content_item1_inp3" size="large" :options="options1" v-model="selectedOptions1" @change="handleChange1">
										</el-cascader>
									</div>
									<div class="personalaccount_content_right_content_item1">
										<span class="personalaccount_content_right_content_item1_txt">详细地址(必填)：</span>
										<textarea @input="inputFn1" class="personalaccount_content_right_content_item1_inp2" id="address" name="" rows="" cols=""></textarea>
									</div>
									<div class="personalaccount_content_right_content_item1">
										<span class="personalaccount_content_right_content_item1_txt">设为默认：</span>
										<div class="personalaccount_content_right_content_item1_lable">
											<input id="itemq" type="radio" name="itemq" value="itemq" @click="onClick1" :checked="checkedValue_z1">
											<label for="itemq"></label>
											<!--<span>男</span>-->
										</div>

									</div>

								</div>
								<div class="personalaccount_content_right_content1_btn1" @click="updateAddressFn">
									确定
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">配送方式</div>

				</div>
				<div class="personalaccount_content_right_head1_border"></div>
				<div class="personalaccount_content_right_content">
					<div class="peisong_head">
						<div class="peisong_select">

						</div>
						<div class="peisong_right_head">
							配送方式
						</div>
						<div class="peisong_left_head">
							信息描述
						</div>

						<div class="peisong_right_head">
							基本费用
						</div>
						<div class="peisong_right_head">
							免费额度
						</div>
					</div>
					<div class="peisong" v-for="(item, index) in peisongData" :key="index">
						<div class="peisong_select">
							<div class="personalaccount_content_right_content_item_lable">
								<input v-model="checkedValue" :id="'item' + index" type="radio" name="item" :for="'item' + index" :value="index">
								<label :for="'item' + index"></label>
								<span></span>
							</div>
						</div>
						<div class="peisong_right" style="color: #333333;">
							{{item.title}}
						</div>
						<div class="peisong_left">

							{{item.describe}}
						</div>
						<div class="peisong_right">
							<div class="peisong_left_content" v-if="item.type == 1">
								{{item.district.ykg}}
							</div>
							<div class="peisong_left_content" v-else>
								{{item.district.ykg_price}}
							</div>
						</div>
						<div class="peisong_right">
							<div class="peisong_left_content">
								{{item.district.free_postage_quota}}
							</div>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_right_content" v-if="selectBool">
					<div class="ziti">选择自提地址</div>
					<select name="" id="" class="hongbao_inp1" v-model="couponSelected" @change="selectDataFn">
						<option value="" style="display: none">请选择自提点</option>
						<option :value="item.id" v-for="(item, index) in selectData" :key="index">{{item.extend}}</option>
					</select>
				</div>

				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">支付方式</div>

				</div>
				<div class="personalaccount_content_right_head1_border"></div>
				<div class="personalaccount_content_right_content">
					<!--					<div class="zhifu_btn">货到付款</div>-->
					<!--					<div class="zhifu_btn1">余额支付</div>-->
					<div :class="{'zhifu_btn1':true,'zhifu_btn':zhifuBool == 1}" @click="zhifuBfN(1)">
						<img src="../../../public/img/weixin.png" alt=""> 微信支付
						<img class="img_absolute" v-if="zhifuBool == 1" src="../../../public/img/select_guige.png" alt="">
					</div>
					<div :class="{'zhifu_btn1':true,'zhifu_btn':zhifuBool == 2}" @click="zhifuBfN(2)">
						<img src="../../../public/img/zhifubao.png" alt=""> 支付宝支付
						<img class="img_absolute" v-if="zhifuBool == 2" src="../../../public/img/select_guige.png" alt="">
					</div>
					<div :class="{'zhifu_btn1':true,'zhifu_btn':zhifuBool == 3}" @click="zhifuBfN(3)" v-if="huodaoBool == true">
						<img src="../../../public/img/huodaofukuan.png" alt=""> 货到付款
						<img class="img_absolute" v-if="zhifuBool == 3" src="../../../public/img/select_guige.png" alt="">
					</div>

				</div>
				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">优惠信息</div>

				</div>
				<div class="personalaccount_content_right_head1_border"></div>
				<div class="personalaccount_content_right_contents">
					<!--					<div class="xinxi_top">-->
					<!--						<div class="xinxi_top_left">-->
					<!--							<span class="biaoti">选择使用的红包：</span>-->

					<!--							<select name="" class="hongbao_inp">-->
					<!--								<option value=""></option>-->
					<!--							</select>-->
					<!--						</div>-->
					<!--						<div class="xinxi_top_right">-->
					<!--							<span>红包码：</span>-->
					<!--							<input type="" name="" id="" value="" class="personalaccount_content_right_content_head_left_inp" />-->
					<!--							<span class="personalaccount_content_right_content_head_left_btn">领取红包</span>-->
					<!--						</div>-->
					<!--					</div>-->
					<!--					<div class="xinxi_top_left1">-->
					<!--						<span class="biaoti">选择收货时间段：</span>-->
					<!--						<select name="" class="hongbao_inp">-->
					<!--								<option value=""></option>-->
					<!--						</select>-->
					<!--					</div>-->
					<div class="xinxi_top_left1">
						<span class="biaoti1">使用积分：</span>

						<input class="jifen_inp" type="text" name="" v-model="jifen" />
						<span>剩余可用积分：{{jifenZong}}（1积分={{bili}}元）</span> 可抵{{jifennum}}元
					</div>
					<div class="xinxi_footer">
						<span>买家留言：</span>
						<textarea class="textareas" placeholder="请输入" @input="textFn" name="" id="" cols="30" rows="10"></textarea>
					</div>
				</div>
				<div class="personalaccount_content_right_footer">
					<div class="personalaccount_content_right_footer_left">
						费用总计
					</div>
					<div class="personalaccount_content_right_footer_center">
						已选{{zongNumber}}件商品订单完成后您可获得{{getjifen}}积分。
					</div>
					<div class="personalaccount_content_right_footer_right">
						<!--						<div class="personalaccount_content_right_footer_right_con">-->
						<!--							<span class="personalaccount_content_right_footer_right_con1">红包抵扣</span>-->
						<!--							<span class="personalaccount_content_right_footer_right_con4">-10</span>-->
						<!--						</div>-->
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con5">商品总额：</span>
							<span class="personalaccount_content_right_footer_right_con2">{{(parseFloat(zongPrice).toFixed(2))}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con1">物流费用：</span>
							<span class="personalaccount_content_right_footer_right_con2">+{{youfeiPrice}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con" v-if="youhuilv != 1">
							<span class="personalaccount_content_right_footer_right_con1">优惠率：</span>
							<span class="personalaccount_content_right_footer_right_con2">{{youhuilv}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con1">积分抵扣：</span>
							<span class="personalaccount_content_right_footer_right_con4">-{{jifennum}}</span>
						</div>

						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con5">订单总金额：</span>
							<span class="personalaccount_content_right_footer_right_con3">￥{{(((parseFloat(zongPrice) + parseFloat(youfeiPrice) - parseFloat(jifennum)) * youhuilv).toFixed(2))}}</span>
						</div>

					</div>
				</div>
				<div class="footer_content">
					<div></div>
					<div class="shopcar_btn" @click="createOrderFn">
						提交订单
					</div>
					<div class="rulebox" v-if="erweimaBool">
						<div class="ruleboxin">
							<div class="rule1">
								<div class="ruletop">
									<span>扫描二维码支付</span>
									<img src="../../../public/img/hideico1.png" alt="" class="_ico1" @click="erweimaFn1">
								</div>
								<div class="rulecount">
									<img class="erwemaImg" :src="erwemaImg" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
	export default {
		name: 'shopcarContent',
		data() {
			return {
				fixedkey: false,
				addressData: [],
				datajson: [], //其他页面传值数据
				zongPrice: 0, //总价
				zongNumber: 0, //总数量
				ruletab: false, //新增地址弹窗
				localData1: {}, //新增地址数据
				checkedValue_z1: false, //是否默认
				options1: regionData,
				selectedOptions1: [],
				orderData: {},
				zhifuBool: 1,
				peisongData: [], //配送方式
				peisongData1: [], //配送备用数据
				selectData: [], //配送区域
				selectBool: false, //判断是否展示
				checkedValue: "", //配送方式选择
				jifenZong: 0,
				bili: 0,
				getjifen: 0,
				jifennum: 0, //积分换算金额
				jifen: '',

				erweimaBool: false, //判断二维码是否出现
				erwemaImg: '',
				http: '',
				youfeiData: {}, //youfeijisuan
				youfeiPrice: 0, //邮费价格
				couponSelected: '', //默认选择自提地址
				huodaoBool: false, //判断货到付款方式展示
				youhuilv: 1, //优惠率
				zongZhongliang:0,//总重量

			}
		},
		watch: {
			checkedValue() {
				let that = this;
				// console.log(that.checkedValue)
				if(that.checkedValue !== '') {
					that.orderData["delivery_id"] = parseInt(that.peisongData[that.checkedValue].id);
					that.youfeiData['delivery_id'] = parseInt(that.peisongData[that.checkedValue].id);
					for(let i in that.peisongData1) {
						if(that.peisongData[that.checkedValue].type == 1 && that.peisongData1[i].type == that.peisongData[that.checkedValue].type) {
							that.selectData = that.peisongData[i].district;
							// that.couponSelected = that.selectData[0].id;
							// that.orderData['district_id'] = that.selectData[0].id;
							that.selectBool = true;
						} else {
							that.selectBool = false;
							that.orderData['district_id'] = ''
						}
						if(that.peisongData[that.checkedValue].type == 4) {
							that.huodaoBool = true;
						} else {
							that.huodaoBool = false;
						}
					}
					// if (that.peisongData[that.checkedValue].type == 1){
					//     that.selectData = that.peisongData1[that.checkedValue].district;
					//     that.couponSelected = that.selectData[0].id;
					//   that.orderData['district_id'] = that.selectData[0].id;
					//     that.selectBool = true;
					// }else{
					//   that.selectBool = false;
					//   that.orderData['district_id'] = ''
					// }

					that.youfeiFn();
				}

			},
			jifen() {
				let that = this;
				var re = /^[1-9]\d*$/; //正整数
				if(!re.test(that.jifen)) {
					that.$message({
						message: '亲，请输入正确积分哦',
						type: 'warning'
					});
					that.jifennum = 0 * that.bili;
					that.jifen = '';
				} else if(that.jifen > that.jifenZong) {
					that.$message({
						message: '亲，已经超过剩余最大积分数了哦',
						type: 'warning'
					});
					that.jifennum = (that.jifenZong * that.bili).toFixed(2);
					that.jifen = that.jifenZong
					that.orderData['integral'] = that.jifenZong;
				} else if(that.jifen * that.bili > Number(that.zongPrice) + Number(that.youfeiPrice)) {
					that.$message({
						message: '亲，您使用的积分已超过订单金额了哦',
						type: 'warning'
					});
					that.jifennum = Number(that.zongPrice) + Number(that.youfeiPrice);
					// console.log(Math.ceil((Number(that.zongPrice) + Number(that.youfeiPrice))/  that.bili))
					that.jifen = Math.ceil((Number(that.zongPrice) + Number(that.youfeiPrice)) / that.bili);
					that.orderData['integral'] = Math.ceil((Number(that.zongPrice) + Number(that.youfeiPrice)) / that.bili);
				} else {
					that.jifennum = (that.jifen * that.bili).toFixed(2);
					that.jifen = that.jifen;
					that.orderData['integral'] = that.jifen;
				}
			},
		},
		created() {
			let that = this;
			// console.log(that.$route.query.datajson)
			that.http = that.$publicUrl.http1;
			if(that.$storage._sessionget('datajson') != null) {
				let datajson = JSON.parse(that.$storage._sessionget('datajson'));
				let zongPrice = that.zongPrice
				let zongNumber = that.zongNumber
				let zongZhongliang = that.zongZhongliang
				let orderArr = [];
				
				for(let item in datajson) {
					orderArr.push({
						'sku_id': datajson[item].data.id,
						number: datajson[item].number,
						type: datajson[item].data.type,
						activity_id: datajson[item].data.activity_id
					});
					datajson[item]['xprice'] = (datajson[item].data.price * datajson[item].data.package * datajson[item].number).toFixed(2);
					zongPrice += parseFloat(datajson[item].data.price * datajson[item].number * datajson[item].data.package)
					zongZhongliang += datajson[item].data.weight * datajson[item].number * datajson[item].data.package;
					zongNumber += parseInt(datajson[item].number);

				}
				console.log(zongZhongliang)
				that.zongZhongliang = zongZhongliang;
				that.orderData['goods'] = JSON.stringify(orderArr);

				that.orderData['user_id'] = that.$storage.get('user_data').user_id;
				that.orderData['pay_type'] = that.zhifuBool

				that.orderData['reserve'] = datajson[0].reserve;

				that.zongPrice = zongPrice.toFixed(2);
				that.zongNumber = zongNumber;
				that.datajson = datajson;
				that.jifenFn();
			}
			that.peisongFn();
			that.selectAddressFn();

		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
			this.toTop()
		},
		methods: {
			goTop() {
				let that = this;
				that.$router.go(-1)
			},
			selectDataFn(e) {
				//获取选中的优惠券
				let that = this;
				that.orderData['district_id'] = e.target.value;

			},
			//查询收货地址
			selectAddressFn() {
				let that = this;
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.addressselects,
						data: qs.stringify({
							user_id: that.$storage.get('user_data').user_id
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							let area_id = data.data[0].district;
							for(let i in data.data) {
								if(data.data[i].status == 1) {
									that.orderData['address_id'] = data.data[i].address_id;
									area_id = data.data[i].address_id;

								}
							}
							// console.log(data.data)

							that.addressData = data.data;

							that.addressPeisongFn(area_id);

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			updateAddressFn() {
				let that = this;
				that.localData1['user_id'] = that.$storage.get('user_data').user_id
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.addressinserts,
						data: qs.stringify(that.localData1),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.$message({
								type: "success",
								message: "添加成功!"
							});
							that.rulebox();
							that.selectAddressFn();

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			addressPeisongFn(area_id) {
				let that = this;
				// that.localData1['user_id'] = that.$storage.get('user_data').user_id
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.deliverygetDelivery,
						data: qs.stringify({
							address_id: area_id,
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							console.log(data.data)
							that.peisongData = data.data;
							that.huodaoBool = false;
							that.checkedValue = '';
							that.zhifuBfN(1);
							that.orderData["delivery_id"] = '';
							that.youfeiPrice = 0;
							// that.checkedValue = data.data[0].id;
							// that.orderData["delivery_id"] = data.data[0].id;
							that.youfeiData['delivery_id'] = data.data[0].id;
							that.youfeiData['address_id'] = area_id;
							// that.youfeiFn();

						} else {

						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			textFn(event) {
				let that = this;
				that.orderData["leave_msg"] = event.currentTarget.value;
			},
			youfeiFn() {
				let that = this;
				// that.localData1['user_id'] = that.$storage.get('user_data').user_id
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.deliverygetDistrict,
						data: qs.stringify(that.youfeiData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							let data_ = data.data;
							let youfeiPrice
							console.log(data_)
							if(that.zongPrice < Number(data_.free_postage_quota) && data_.delivery_type !== 1 && Number(data_.continued_heavy) == 0 ){
									youfeiPrice = data_.ykg_price

							}else if(that.zongPrice < Number(data_.free_postage_quota) && data_.delivery_type !== 1 && that.zongZhongliang <= Number(data_.ykg)){
								youfeiPrice = data_.ykg_price
							}else if(that.zongPrice < Number(data_.free_postage_quota) && data_.delivery_type !== 1 && that.zongZhongliang > data_.ykg){
								youfeiPrice = Math.ceil((that.zongZhongliang - data_.ykg) / data_.continued_heavy) * data_.heavy_price + Number(data_.ykg_price);
							} else {
		
								youfeiPrice = 0;
							}
							console.log(that.zongZhongliang )
							console.log( data_.ykg)
							console.log(data_.ykg_price)
							
							that.youfeiPrice = youfeiPrice;
			

						} else {
							that.youfeiPrice = 0;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			jifenFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.jifennumber,
						data: qs.stringify({
							user_id: that.$storage.get('user_data').user_id,
							rank: that.$storage.get('user_data').rank_id,
							money: Number(that.zongPrice) + Number(that.youfeiPrice)
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						console.log(data)
						if(data.stateCode == 10000) {
							that.jifenZong = data.jifen
							that.bili = data.bili
							that.getjifen = data.get
							that.youhuilv = data.rate
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			orderpayFn(id) {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.orderpay,
						data: qs.stringify({
							id: id,
              pay_ambient: 1,
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						console.log(data)
						if(data.stateCode == 10000) {
							console.log(data)
							that.erweimaFn();
							that.erwemaImg = data.data;
							that.setInt(id);

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			erweimaFn() {
				let that = this;
				that.erweimaBool = !that.erweimaBool
			},
			erweimaFn1() {
				let that = this;
				that.erweimaBool = !that.erweimaBool;
				that.$storage._sessionremove('datajson')
				that.$router.push({
					path: "/shopcarResult",
					query: {
						type: 2,
					}
				});
			},
			createOrderFn() {
				let that = this;
				// console.log(that.orderData)
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.ordercreated,
						data: qs.stringify(that.orderData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							let arr = [];
							for(let i in that.datajson) {
								arr.push(that.datajson[i].cart_id);
							}
							that.deleteFn(arr.toString());
							that.orderpayFn(data.data.id);

						} else if(data.stateCode == 10001) {
							let arr = [];
							for(let i in that.datajson) {
								arr.push(that.datajson[i].cart_id);
							}
							that.deleteFn(arr.toString());
							that.$storage._sessionremove('datajson')
							that.$router.push({
								path: "/shopcarResult",
								query: {
									type: 1,
								}
							});
						} else if(data.stateCode == 40006) {

							that.caigouFn();
						} else if(data.stateCode == 40005) {

							that.$message({
								message: '采购额度不足，请联系审核员进行修改哦，亲！',
								type: 'warning'
							});
						} else {

							that.$message({
								message: data.message,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			caigouFn() {
				let that = this;
				// console.log(that.orderData)
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.purchasecreated,
						data: qs.stringify(that.orderData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.$storage._sessionremove('datajson')
							that.$router.push({
								path: "/shopcarResult",
								query: {
									type: 1,
								}
							});

						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			deleteFn(cart_id) {
				let that = this;
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.usercartdelcart,
						data: qs.stringify({
							cart_id: cart_id,

						}),
					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {

						} else {

						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			//定时查询订单
			setInt(id) {
				let that = this;
				var sec = 24;
				var interval = setInterval(
					function() {
						sec--;
						if(sec < 0) {
							clearInterval(interval);
							that.erweimaFn();
							that.$storage._sessionremove('datajson')
							that.$router.push({
								path: "/shopcarResult",
								query: {
									type: 2,
								}
							});

						} else {
							axios({
									method: 'post',
									headers: {
										'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
									},
									url: that.$publicUrl.http1 + that.$publicUrl.orderpayStatus,
									data: qs.stringify({
										id: id,
									}),

								})
								.then(function(response) {
									//						console.log(response);
									let data = response.data;
									if(data.stateCode == 10000) {
										that.$message({
											message: data.data,
											type: 'warning'
										})
										clearInterval(interval);
										that.erweimaFn();
										that.$storage._sessionremove('datajson')
										that.$router.push({
											path: "/shopcarResult",
											query: {
												type: 1,
											}
										});
									} else {

									}
								})
								.catch(function(error) {
									console.log(error);
								});
						}

					}.bind(that),
					5000
				);
			},
			peisongFn() {
				let that = this;
				// that.localData1['user_id'] = that.$storage.get('user_data').user_id
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.deliverylists,
						data: qs.stringify({}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							console.log(data.data)
							that.peisongData1 = data.data;

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clickFn(item, index) {
				let that = this;
				let arr = that.addressData
				for(let i in arr) {
					arr[i]['status'] = 0;
				}
				arr[index]['status'] = 1;
				that.orderData['address_id'] = arr[index].address_id;
				that.youfeiData['address_id'] = arr[index].address_id;

				that.addressData = arr;
				that.orderData['district_id'] = '';
				that.selectBool = false;
				that.addressPeisongFn(arr[index].address_id);

				// that.youfeiFn();
			},
			zhifuBfN(index) {
				let that = this;
				that.zhifuBool = index;
				that.orderData['pay_type'] = index;
			},
			rulebox() {
				let that = this;
				that.ruletab = !that.ruletab
			},
			inputFn1(event) {
				let that = this;
				that.localData1[event.currentTarget.id] = event.currentTarget.value;

			},
			handleChange1(value) {
				let that = this;
				let arr = [];
				for(let i = 0; i < value.length; i++) {
					arr.push(CodeToText[value[i]])
				}
				that.localData1['address_name'] = arr.join(',');

			},
			onClick1() { // 支持单个单选框选中/取消相互切换，选中态与isChecked保持一致
				let that = this;
				that.checkedValue_z1 = !that.checkedValue_z1;
				if(that.checkedValue_z1 == true) {
					that.localData1['status'] = 1;
				} else {
					that.localData1['status'] = 0;
				}

			},
			toTop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if(top <= 0) {
						clearInterval(timeTop);
					}
				}, 10);
			},
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log()
				if(scrollTop >= 300) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},
			toggleSelection(rows) {
				if(rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val)
			},
			getRowClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(rowIndex == 0) {
					return "font-size:16px;color:#333333;text-align:center;border-right:1px solid #eeeeee;font-weight:500;background:#eeeeee";
				} else {
					return "";
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {

				return "text-align:center;font-size:16px;color:#333333;border:1px solid #eeeeee";

			},
			returns() {
				this.$router.push({
					path: '/shopcarList',
					query: {
						id: '1'
					}
				})
			},
			tomap() {
				this.$router.push({
					path: '/personalAddress',
					query: {}
				})

			}

		},

	}
</script>

<style scoped>
	.name_item {
		width: 100%;
		display: flex;
		flex-wrap: nowrap;
	}
	
	.name_item_left {
		width: 80px;
		height: 80px;
		/*border: 1px solid #cccccc;*/
		padding: 5px;
		box-sizing: border-box;
	}
	
	.name_item_left img {
		display: inline-block;
		width: 100%;
	}
	
	.name_item_right {
		width: calc(100% - 120px);
		height: 45px;
		margin-top: 20px;
		margin-left: 20px;
	}
	
	#shopcarContent {
		width: 100%;
		background: #f9f9f9;
		padding-bottom: 30px;
	}
	
	#shopcarListCon {
		width: 1200px;
		margin: 0 auto;
	}
	
	.shopcarList_head {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.shopcarList_head_right {
		display: flex;
		flex-wrap: nowrap;
	}
	
	.shopcarList_head_right_item {
		width: 210px;
		height: 40px;
		line-height: 40px;
		background-image: url(../../assets/img/personalhome/shopcarhead.png);
		background-size: 100% 100%;
		text-align: center;
		font-size: 16px;
		color: #333333;
		margin-top: 10px;
	}
	
	.shopcarList_head_right_item1 {
		width: 210px;
		height: 40px;
		line-height: 40px;
		background-image: url(../../assets/img/personalhome/shpcarhead1.png);
		background-size: 100% 100%;
		text-align: center;
		font-size: 16px;
		color: #ffffff;
		margin-top: 10px;
	}
	
	.personalaccount_content_right_content {
		margin-bottom: 30px;
		background: #ffffff;
		box-sizing: border-box;
		padding: 20px;
		padding-top: 0;
	}
	
	.personalaccount_content_right_contents {
		margin-bottom: 20px;
		background: #ffffff;
		padding-bottom: 20px;
		padding-top: 1px;
	}
	
	.personalaccount_content_right_head1 {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #ffffff;
		/*border-bottom: 2px solid #db1e34;*/
		color: #111111;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		/*margin-bottom: 20px;*/
	}
	
	.personalaccount_content_right_head1_border {
		height: 2px;
		width: calc(100% - 40px);
		margin: 0 auto;
		background: #db1e34;
	}
	
	.personalaccount_content_right_head_right {
		color: #db1e34;
		font-size: 16px;
	}
	
	.personalaccount_content_right_head {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #ffffff;
		/*border-bottom: 2px solid #db1e34;*/
		color: #111111;
		font-size: 18px;
		/*border-bottom: 1px solid #DC1E33;*/
		margin-top: 20px;
	}
	
	.spListAll {
		width: 100%;
		height: 50px;
		line-height: 50px;
		padding-right: 20px;
		box-sizing: border-box;
		font-size: 16px;
		color: #DC1E33;
		text-align: right;
		border: 1px solid #eeeeee;
		border-top: none;
		background: #ffffff;
	}
	
	.address_item {
		display: inline-block;
		width: 275px;
		height: 120px;
		background: #ffffff;
		border: 1px solid #dddddd;
		box-shadow: 0 1px 6px #dddddd;
		box-sizing: border-box;
		padding: 10px;
		margin-top: 20px;
		margin-left: calc((100% - 275px * 4) / 8);
		margin-right: calc((100% - 275px * 4) / 8);
	}
	
	.address_item_active {
		border: 1px solid #DC1E33;
		box-shadow: 0 1px 6px #db1e34;
	}
	
	.address_item_top {
		font-size: 18px;
		color: #333333;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.address_item_txt {
		font-size: 14px;
		color: #666666;
		margin-top: 10px;
	}
	
	.address_item_txt1 {
		font-size: 14px;
		color: #333333;
		margin-top: 10px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.address_item_txt1s {
		color: #D81023;
	}
	
	.address_btn {
		width: 120px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #D81023;
		color: #D81023;
		background: #ffffff;
		border-radius: 5px;
		font-size: 16px;
		text-align: center;
		margin-top: 20px;
		margin-left: 15px;
		cursor: pointer;
	}
	
	.peisong {
		width: 100%;
		height: 70px;
		text-align: center;
		font-size: 14px;
		color: #666666;
		display: flex;
		flex-wrap: nowrap;
		background: #ffffff;
		border: 1px solid #eeeeee;
		border-top: none;
	}
	
	.peisong_head {
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 14px;
		color: #666666;
		display: flex;
		flex-wrap: nowrap;
		background: #eeeeee;
		border: 1px solid #eeeeee;
		border-top: none;
	}
	
	.peisong_left {
		width: 700px;
		padding-top: 20px;
		height: 70px;
		border-left: 1px solid #eeeeee;
	}
	
	.peisong_left_head {
		width: 700px;
	}
	
	.peisong_left_top {
		margin-top: 10px;
		font-size: 16px;
		color: #333333;
		height: 21px;
		line-height: 21px;
	}
	
	.peisong_left_content {
		height: calc(100% - 21px);
	}
	
	.peisong_right:first-child {}
	
	.peisong_right {
		width: calc((100% - 700px) / 3);
		border-left: 1px solid #eeeeee;
		/*border-right: 1px solid #eeeeee;*/
		height: 70px;
		line-height: 70px;
	}
	
	.peisong_right_head {
		width: calc((100% - 700px) / 3);
		border-left: 1px solid #eeeeee;
		border-right: 1px solid #eeeeee;
		/*height: 70px;*/
		/*line-height: 70px;*/
	}
	
	.peisong_select {
		width: 60px;
		border-right: 1px solid #eeeeee;
	}
	
	.footer_content {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		margin: 40px auto;
	}
	
	.shopcar_btn {
		width: 160px;
		text-align: center;
		height: 50px;
		line-height: 50px;
		background: #D81023;
		color: #ffffff;
		font-size: 24px;
		border-radius: 5px;
		cursor: pointer;
	}
	
	.personalaccount_content_right_content_item_lable {
		line-height: 30px;
		width: 40px;
		margin-left: 15px;
		margin-top: 15px;
		position: relative;
	}
	
	.personalaccount_content_right_content_item_lable span {
		display: inline-block;
		font-size: 16px;
		color: #333333;
		margin-left: 20px;
		line-height: 40px;
	}
	
	input[type="radio"] {
		width: 20px;
		height: 20px;
		opacity: 0;
		position: relative;
		top: 4px;
		left: 5px;
	}
	
	label {
		position: absolute;
		left: 5px;
		top: 9px;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1px solid #666666;
		display: inline-block;
	}
	/*设置选中的input的样式*/
	/* + 是兄弟选择器,获取选中后的label元素*/
	
	input:checked+label {
		background-color: #DC1E33;
		border: 1px solid #DC1E33;
	}
	
	input:checked+label::after {
		position: absolute;
		content: "";
		width: 5px;
		height: 10px;
		top: 3px;
		left: 6px;
		border: 2px solid #fff;
		border-top: none;
		border-left: none;
		transform: rotate(45deg)
	}
	
	.zhifu_btn1 {
		font-size: 20px;
		color: #333333;
		width: 200px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		margin-top: 20px;
		background: #ffffff;
		border: 1px solid #cccccc;
		/*box-shadow: 0px 1px 6px #cccccc;*/
		display: inline-block;
		margin-left: 20px;
		cursor: pointer;
		position: relative;
	}
	
	.img_absolute {
		position: absolute;
		right: 0;
		bottom: 0;
	}
	
	.zhifu_btn {
		color: #DC1E33;
		border: 1px solid #DC1E33;
	}
	
	.personalaccount_content_right_content_head_left_inp {
		width: 240px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-left: 10px;
		border: 1px solid #dddddd;
		background: #ffffff;
	}
	
	.personalaccount_content_right_content_head_left_btn {
		width: 120px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #dddddd;
		box-shadow: 0 1px 3px #dddddd;
		text-align: center;
		background: white;
		margin-left: 30px;
		font-size: 16px;
		background: #DC1E33;
		color: #ffffff;
		cursor: pointer;
		display: inline-block;
	}
	
	.xinxi_top {
		margin-top: 20px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
	}
	
	.xinxi_top_left {
		font-size: 16px;
		color: #333333;
		height: 40px;
		line-height: 40px;
	}
	
	.xinxi_top_left1 {
		font-size: 16px;
		color: #333333;
		height: 40px;
		line-height: 40px;
		margin-left: 20px;
		margin-top: 20px;
	}
	
	.xinxi_top_left1 span {
		color: #D81023;
	}
	
	.xinxi_footer {
		font-size: 16px;
		color: #333333;
		/*height: 40px;*/
		/*line-height: 40px;*/
		margin-left: 20px;
		display: flex;
		flex-wrap: nowrap;
		/*justify-content: space-between;*/
	}
	
	.textareas {
		width: calc(100% - 100px);
		height: 80px;
		display: inline-block;
		margin-top: 20px;
		box-sizing: border-box;
		padding-left: 10px;
		padding-top: 10px;
		/*margin-left: 20px;*/
	}
	
	.xinxi_footer span {
		color: #666666;
		display: inline-block;
		width: 80px;
		height: 80px;
		margin-top: 20px;
		line-height: 80px;
	}
	
	.biaoti {
		display: inline-block;
		width: 160px;
		color: #333333!important;
	}
	
	.biaoti1 {
		display: inline-block;
		color: #333333!important;
	}
	
	.hongbao_inp {
		display: inline-block;
		width: 240px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #cccccc;
	}
	
	.hongbao_inp1 {
		display: inline-block;
		width: calc(100% - 120px);
		/*margin-left: 20px;*/
		height: 40px;
		line-height: 40px;
		border: 1px solid #cccccc;
		font-size: 16px;
		color: #333333;
	}
	
	.jifen_inp {
		display: inline-block;
		width: 70px;
		height: 40px;
		line-height: 40px;
		border-radius: 5px;
		text-align: center;
		border: 1px solid #cccccc;
		margin-right: 20px;
	}
	
	.personalaccount_content_right_footer {
		display: flex;
		flex-wrap: nowrap;
		width: 100%;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 10px;
		/*height: 190px;*/
		background: #eeeeee;
		margin-top: 30px;
	}
	
	.personalaccount_content_right_footer_left {
		height: calc(100% - 20px);
		line-height: 160px;
		color: #333333;
		font-size: 24px;
		margin-left: 10px;
	}
	
	.personalaccount_content_right_footer_center {
		width: 410px;
		font-size: 16px;
		color: #333333;
		height: 130px;
		box-sizing: border-box;
		padding-top: 80px;
	}
	
	.personalaccount_content_right_footer_right_con {
		font-size: 16px;
		color: #333333;
		height: 35px;
		line-height: 35px;
		/*text-align: right;*/
	}
	
	.personalaccount_content_right_footer_right_con span {
		display: inline-block;
		margin-left: 5px;
	}
	
	.personalaccount_content_right_footer_right_con1 {
		display: inline-block;
		width: 100px;
		text-align: right;
	}
	
	.personalaccount_content_right_footer_right_con5 {
		display: inline-block;
		width: 100px;
		text-align: right;
	}
	
	.personalaccount_content_right_footer_right_con2 {
		color: #dc1e33;
	}
	
	.personalaccount_content_right_footer_right_con3 {
		font-size: 20px;
		color: #dc1e33;
	}
	
	.rulebox {
		width: 100%;
		position: fixed;
		height: 100%;
		z-index: 10;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6)
	}
	
	.ruleboxin {
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.rule {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 690px;
		height: 534px;
		background-color: #ffffff;
		border-radius: 10px;
		z-index: 100;
		transform: translate(-50%, -50%);
		-webkit-box-shadow: 0 1px 5px #ccc;
		box-shadow: 0 1px 5px #ccc;
		box-sizing: border-box;
		/*padding:0px 40px;*/
		/*padding-bottom: 20px;*/
	}
	
	.rule1 {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 400px;
		height: 450px;
		background-color: #ffffff;
		border-radius: 10px;
		z-index: 100;
		transform: translate(-50%, -50%);
		-webkit-box-shadow: 0 1px 5px #ccc;
		box-shadow: 0 1px 5px #ccc;
		box-sizing: border-box;
		/*padding:0px 40px;*/
		/*padding-bottom: 20px;*/
	}
	
	.erwemaImg {
		display: block;
		width: 90%;
		margin: 20px auto;
	}
	
	.ruletop {
		width: 100%;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 18px;
		font-weight: 600;
		color: white;
		background: #d81023;
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		padding-left: 20px;
		/*padding-right:20px;*/
	}
	
	.rulecount {
		width: 100%;
		/*height:70vh;*/
		overflow: scroll;
		overflow-x: scroll;
	}
	
	.rulecount::-webkit-scrollbar {
		display: none;
	}
	
	._ico1 {
		width: 30px;
		height: 30px;
		position: absolute;
		top: 15px;
		right: 20px;
		display: block;
		cursor: pointer;
	}
	
	.personalaccount_content_right_content1 {
		width: 552px;
		margin: 0 auto;
		margin-top: 40px;
	}
	
	.personalaccount_content_right_content_item1 {
		width: 100%;
		margin-top: 20px;
		/*position: relative;*/
		display: flex;
		flex-wrap: nowrap;
	}
	
	.personalaccount_content_right_content_item1_txt {
		width: 190px;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 18px;
		text-align: right;
	}
	
	input {
		outline: none;
		border: 0;
	}
	
	.personalaccount_content_right_content_item1_inp {
		border: 1px solid #dddddd;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 220px);
		box-sizing: border-box;
		padding-left: 20px;
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item1_inp1 {
		border: 1px solid #dddddd;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 120px);
		box-sizing: border-box;
		padding-left: 20px;
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item1_inp3 {
		/*border: 1px solid #dddddd;*/
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 120px);
		box-sizing: border-box;
		/*padding-left: 20px;*/
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item1_inp2 {
		border: 1px solid #dddddd;
		display: inline-block;
		height: 100px;
		line-height: 30px;
		width: calc(100% - 120px);
		box-sizing: border-box;
		padding-left: 20px;
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content1_btn1 {
		width: 160px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin: 30px auto;
		color: #FFFFFF;
		font-size: 24px;
		background: #DC1E33;
		border-radius: 5px;
		cursor: pointer;
	}
	
	.personalaccount_content_right_content_item1_lable {
		line-height: 30px;
		width: calc(100% - 120px);
		position: relative;
		/*margin-left: 20px;*/
	}
	
	.personalaccount_content_right_content_item1_lable span {
		display: inline-block;
		font-size: 16px;
		color: #333333;
		margin-left: 20px;
		line-height: 40px;
	}
	
	.ziti {
		display: inline-block;
		width: 120px;
		text-align: left;
		color: #333333;
		font-size: 18px;
		height: 50px;
		line-height: 50px;
		/*margin-left: 20px;*/
		margin-top: 20px;
	}
</style>
